import { Injectable } from '@angular/core';
import { permissions } from '../../constants/Permissions';

@Injectable({
  providedIn: 'root',
})
export class ConstantsService {
public readonly permissions = permissions;
}
